import { logout } from '@stilingue/st-auth-utils';

export function error401Handler() {
  logout();
  window.location.reload();
}
